import { render } from "./MTClickbait.vue?vue&type=template&id=edc37a24&scoped=true&ts=true"
import script from "./MTClickbait.vue?vue&type=script&lang=ts"
export * from "./MTClickbait.vue?vue&type=script&lang=ts"

import "./MTClickbait.vue?vue&type=style&index=0&id=edc37a24&lang=scss&scoped=true"

import exportComponent from "/home/app/mt-partners/frontend/affiliate/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edc37a24"]])

export default __exports__
import QPageContainer from 'quasar/src/components/page/QPageContainer.js';
import QPage from 'quasar/src/components/page/QPage.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPageContainer,QPage});
